<template>
  <div>
    <v-row v-if="showDialog" justify="center">
      <v-dialog v-model="showDialog" persistent max-width="600px">
        <GDPR
          :getSurveyData="getSurveyData"
          @show-dialog="showDialog = true"
          @close-dialog="showDialog = false"
        ></GDPR>
      </v-dialog>
    </v-row>

    <UnpaidOrdersSnackbar />

    <v-row justify="center" align="start">
      <v-col cols="12" md="12" sm="12">
        <Dashboard v-if="dashboard" :loadingBasket="loadingBasket" />
        <HomePage v-else :loadingBasket="loadingBasket" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

import GDPR from "@/components/account/GDPR.vue";
import UnpaidOrdersSnackbar from "@/components/dashboard/UnpaidOrdersSnackbar.vue";

import HomePage from "@/components/dashboard/pages/HomePage.vue";
import Dashboard from "@/components/dashboard/pages/Dashboard.vue";

export default {
  name: "Home",

  components: {
    GDPR,
    UnpaidOrdersSnackbar,
    HomePage,
    Dashboard,
  },

  data: () => ({
    loadingCustomer: false,
    loadingBasket: true,
    showDialog: false,
    getSurveyData: {},
  }),

  mounted() {
    this.checkAutoLoad();
    this.getSurvey();
    this.getSelectedDeliveryAddress();
  },

  async activated() {
    if (this.$store.getters.retrieveAdmin.account_type == "C1") {
      await this.getTrollys();
    }
    this.loadingBasket = false;
  },

  computed: {
    ...mapGetters(["retrieveCustomerAddress"]),

    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    dashboard() {
      return this.$store.getters.retrieveDashboardHomePage;
    },

    style() {
      const Style = {};

      return Style;
    },
    buttonStyle() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].primary,
      };

      return Style;
    },
    companyHomePageText() {
      return this.$store.getters.retrieveCompanyHomePageText;
    },
    companyStyle() {
      const Style = {
        color: this.$vuetify.theme.themes[this.theme].primary,
        "text-align": "center",
        "font-size": "4rem !important",
        "font-weight": 400,
        // "line-height": "3.125rem",
        "letter-spacing": "normal !important",
        "font-family": "Roboto, sans-serif !important",
      };

      console.log("-- Checking Style");
      console.log(this.$store.getters.retrieveAllConfigs);
      console.log(
        this.$store.getters.retrieveAllConfigs.company_home_page_text_font_size
      );

      if (
        this.$store.getters.retrieveAllConfigs.company_home_page_text_font_size
      ) {
        Style["font-size"] =
          this.$store.getters.retrieveAllConfigs
            .company_home_page_text_font_size + "px";
      }

      return Style;
    },

    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },
  },
  methods: {
    ...mapActions(["getFAQ", "getTrollys", "getSelectedDeliveryAddress"]),

    OrderHereRedirect() {
      if (this.trolly) {
        this.$router.push({ name: "OrdersSearch" });
        return;
      } else if (this.$store.getters.retrieveHasMultipleTrollys) {
        //Push Search first because when we go back from selecting a basket we want to be on the search page
        this.$router.push({ name: "OrdersSearch" });
        this.$router.push({ name: "OrdersBasketSelection" });
        return;
      } else {
        this.$router.push({ name: "OrdersCreate" });
        return;
      }
    },

    async getSurvey() {
      console.log(" -- Get Survey");
      let stringPayload = JSON.stringify({
        userId: this.$store.getters.retrieveUser.userNum,
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
      });
      const params = new URLSearchParams();
      params.append("params", stringPayload);

      await axios
        .post("get-survey", params)
        .then((response) => {
          if (response.data.success == true) {
            this.getSurveyData = response.data;

            console.log("-- Home Survey Data");
            console.log(response.data);

            if (response.data.cookies_accept == null) {
              this.showDialog = true;

              console.log("-- Re-va;odat");
              console.log(this.getSurveyData);
            }

            return response.data.success;
          } else {
            return response.data.success;
          }
        })
        .catch((e) => {
          console.log(e);
          return false;
        });
    },

    checkAutoLoad() {
      console.log("-- Checking Autoload");

      if (this.$store.getters.retrieveAnon) {
        this.$router.push({ name: "OrdersCreate" });
      } else {
        switch (
          parseInt(
            this.$store.getters.retrieveAllConfigs
              .orders_autoload_date_selection
          )
        ) {
          case 1:
            console.log("-- Autoload Date Selection");
            // if (this.$store.getters.retrieveCurrentTrolly) {
              
            //   this.$router.push({ name: "OrdersSearch" });
            // } else {
            //   this.$router.push({ name: "OrdersCreate" });
            // }

            this.$router.push({ name: "OrdersCreate" });
            break;
        }
      }
    },
  },
};
</script>


<style lang="sass">
@import "~vuetify/src/styles/styles.sass"
</style>
